import { Box, CircularProgress, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useLocation, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
//----------------------------------------------------------------------
import { CalendarUI } from '../../../utils/Events/Calendar';
import EventPageLayout from '../../../utils/Events/EventPageLayout';
import API from '../../../api';

export default function Events() {
  const [celebrations, setCelebrations] = useState([]);
  const [isCelebrationsApiCalled, setIsCelebrationsApiCalled] = useState(false);
  const [events, setEvents] = useState([]);
  const [isEventsApiCalled, setIsEventsApiCalled] = useState(false);

  const getEventsList = () => {
    API.get('/events').then((response) => {
      const newEvents = [];

      response.data.forEach((event) => {
        newEvents.push({
          start: new Date(event.start_date),
          end: new Date(event.end_date),
          allDay: true,
          type: 'event',
          ...event,
        });
      });
      setEvents(newEvents);
      setIsEventsApiCalled(true);
    });
  };

  const getCelebrationsList = () => {
    API.get('/celebrations').then((response) => {
      const newCelebrations = [];

      response.data.forEach((celebration) => {
        newCelebrations.push({
          start: new Date(celebration.start_date),
          end: new Date(celebration.end_date),
          allDay: true,
          type: 'celebration',
          ...celebration,
        });
      });
      setCelebrations(newCelebrations);
      setIsCelebrationsApiCalled(true);
    });
  };

  useEffect(() => {
    getEventsList();
    getCelebrationsList();
  }, []);

  // general
  const location = useLocation();
  const requestDay = location.state ? location.state.requestDay : null;

  return (
    <>
      {isCelebrationsApiCalled && isEventsApiCalled ? (
        <EventPageLayout
          isAdmin={false}
          hasAuth={false}
          celebrations={celebrations}
          events={events}
          getEvents={getEventsList}
          getCelebrations={getCelebrationsList}
        >
          <CalendarUI requestDay={requestDay} />
        </EventPageLayout>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <CircularProgress />
        </Box>
      )}
    </>
  );
}
